enum AccountActionArrayKeys {
  KycPendingApproval = 'pending_approval',
  KycVerifyIdentity = 'verify_identity',
  AddAccount = 'add_account',
  DeleteAccount = 'delete',
}

export default AccountActionArrayKeys;
